import queryString, { ParsedQuery } from 'query-string';
import rrd from 'react-router-dom';
import { EncodingOperation, EnvService, IStorage, IStorageCookie, ObjectService, ParsedNameValue, URLOperation } from "namirasoft-core";
import { NamirasoftAccountServer, TokenManager } from "namirasoft-account";
import { NSRouterMaker, NSRouterMakerProps } from 'namirasoft-site-react';
import { NSARouterMakerComponent } from "./NSARouterMakerComponent";
import { NSARouterMakerProps } from "./NSARouterMakerProps";
import { NSAConsentPage } from './pages/NSAConsentPage';

export class NSARouterMaker
{
    private product_id: string;
    private storage: IStorage;
    private setState: () => void;
    private component: NSARouterMakerComponent;
    private location: rrd.Location;
    private navigate: rrd.NavigateFunction;
    constructor(product_id: string, storage: IStorage, setState: () => void, component: NSARouterMakerComponent,
        location: rrd.Location, navigate: rrd.NavigateFunction
    )
    {
        this.product_id = product_id;
        this.storage = storage;
        this.setState = setState;
        this.component = component;
        this.location = location;
        this.navigate = navigate;
        this.getProps = this.getProps.bind(this);
        this.getQueryStrings = this.getQueryStrings.bind(this);
        this.getQuery = this.getQuery.bind(this);
        this.getLink = this.getLink.bind(this);
        this.redirect = this.redirect.bind(this);
        this.onRender = this.onRender.bind(this);
    }
    private getProps(ns_router_maker_props: NSRouterMakerProps): NSARouterMakerProps
    {
        let Cookies = process.env.REACT_APP_ACCOUNT_TOKEN;
        let storage = new IStorageCookie({ domain: ".namirasoft.com", path: "/" }, Cookies);
        let token_manager = new TokenManager(storage, () => { });

        let REACT_APP_BASE_URL_ACCOUNT = new EnvService("REACT_APP_BASE_URL_ACCOUNT", true).getString();
        let server = new NamirasoftAccountServer(REACT_APP_BASE_URL_ACCOUNT, token_manager, ns_router_maker_props.notifier.onError);

        return {
            product_id: this.product_id,
            account: {
                token_manager,
                server,
            },
            url: {
                getLink: this.getLink,
                redirect: this.redirect,
                getQueryStrings: this.getQueryStrings,
                getQuery: this.getQuery,
            },
            ...ns_router_maker_props
        };
    }
    getQueryStrings(): ParsedQuery
    {
        return queryString.parse(this.location.search);
    }
    getQuery(name: string, base64: boolean = false): string
    {
        let query = this.getQueryStrings();
        let item = query[name];
        let ans = new ObjectService(item).getString();
        if (base64)
            try
            {
                ans = EncodingOperation.Base64Decode(ans);
            } catch (error)
            {
                ans = "";
            }
        return ans;
    }
    getLink(sub: string, customQuery: { [name: string]: ParsedNameValue })
    {
        if (!customQuery)
            customQuery = {};
        return URLOperation.getLink("", sub, customQuery);
    }
    redirect(sub: string, customQuery: { [name: string]: ParsedNameValue }): void
    {
        let ans = this.getLink(sub, customQuery);
        this.navigate(ans);
    }
    onRender(): React.JSX.Element
    {
        let maker = new NSRouterMaker(this.storage, this.setState, {
            onRender: (ns_router_maker_props: NSRouterMakerProps) =>
            {
                let props = this.getProps(ns_router_maker_props);
                let banned = false;
                if (props.account.token_manager.exists())
                {
                    banned = props.account.token_manager.getUserData(user => user.banned, false);
                    if (!banned)
                    {
                        return <NSAConsentPage
                            {...props}
                            product_id={this.product_id}
                            onAccepted={() =>
                            {
                                return this.component.onRenderOnLogin(props);
                            }}
                        />;
                    }
                }
                return this.component.onRenderOnLogout(props, banned);
            }
        });

        return maker.onRender();
    }
};